import { UrlConstants } from "../url.constants";
export class ApiArcgisItemsConstants {
    static URL = UrlConstants.API_V2 + "ArcGISItem";
}
